// src/frontend_react/src/components/ui/Badge/Badge.js
import React from 'react';
import styles from './Badge.module.css';

const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = '',
  style,
  alignSelf,
  flexGrow,
  ...props
}) => {

  const badgeStyle = { ...style };
  if (alignSelf) badgeStyle.alignSelf = alignSelf;
  if (flexGrow) badgeStyle.flexGrow = flexGrow;

  return (
    <span
      className={`${styles.badgeBase} ${styles[variant] || styles.default} ${styles[size]} ${className}`}
      style={badgeStyle}
      {...props}
    >
      {icon && <span className={styles.badgeIcon}>{icon}</span>}
      {children}
    </span>
  );
};

export default Badge;